<template>
    <v-layout xs12 row class="mx-0">
        <v-flex xs6 class="pr-3">
            <v-autocomplete
                    :items="countries"
                    :label="$vuetify.lang.t('$vuetify.next_destination_country')+ ' *'"
                    :rules="[rules.required]"
                    item-text="country_name"
                    item-value="country_name"
                    outlined
                    type="text"
                    v-model="visa.extra.application_data.next_destination_country"
            ></v-autocomplete>
        </v-flex>
        <v-flex xs6 >
            <v-text-field
                    :label="$vuetify.lang.t('$vuetify.next_flight_number')+ ' *'"
                    :rules="[rules.required]"
                    outlined
                    type="text"
                    v-model="visa.extra.application_data.next_flight_number"
            ></v-text-field>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({
            rules: {
                required: value => !!value || "Required.",
            },
        }),
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            countries() {
                return this.$store.state.CountryForTouristList.all;
            }
        },
        methods: {
            addressChanged(e) {
                this.visa.extra.application_data.address = e;
            }
        },
    };
</script>

<style>
</style>
